<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Треки</h4>
                            <p class="card-category"></p>
                            <div class="row stats-block mt10" v-if="data">
                                <span>Количество альбомов: <span class="number">{{ albums.length }}</span></span>
                                <span>Количество треков: <span class="number">{{ tracksCount }}</span> </span>
                            </div>

                            <div class="row mt10">

                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Альбом</label>
                                        <select v-model="album" id="category-filter"
                                                @change="saveFilters('t_album', album)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option v-for="a in albums" v-bind:value="a.id">{{ a.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="status" id="status-filter"
                                                @change="saveFilters('t_status', status)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="1">Активен</option>
                                            <option value="0">Не активен</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Фильтровать
                                    </button>
                                </div>
                                <div class="col-md-2"></div>
                                <div class="col-md-4">
                                    <button type="submit" class="btn btn-success btn-fill float-right"
                                            @click.prevent="add">
                                        Добавить трек
                                    </button>
                                </div>
                            </div>

                        </template>
                        <div class="table-responsive">
                            <table class="table" v-bind:class="{ 'loading-state': loading }">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'sort'">сортировка</span>
                                        <span v-else-if="column === 'album'">альбом</span>
                                        <span v-else-if="column === 'artist'">артист</span>
                                        <span v-else-if="column === 'title'">название</span>
                                        <span v-else-if="column === 'is_premium'">премиум</span>
                                        <span v-else-if="column === 'is_trendy'">популярное</span>
                                        <span v-else-if="column === 'src_full'">трек</span>
                                        <span v-else-if="column === 'image_src_full'">фон</span>
                                        <span v-else-if="column === 'status'">статус</span>
                                        <span v-else-if="column === 'duration'">длительность</span>
                                        <span v-else>{{column}}</span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data">
                                    <slot :row="item">
                                        <td v-for="column in columns">
                                            <span v-if="column === 'translations'">{{ item[column] }}</span>
                                            <div v-else-if="column === 'image_src_full'" @click="edit(item['id'])">
                                                <div v-if="item[column]" class="device-block device1"
                                                     :style="{ backgroundImage: 'url(' + item[column] + ')' }">
                                                </div>
                                                <img class="device1" src="/static/img/track.png" v-if="!item[column]"/>
                                            </div>
                                            <span v-else-if="column === 'duration'">{{ item[column]}}</span>
                                            <span v-else-if="column === 'src_full'">
                                                <audio :src="item[column]" onloadstart="this.volume=0.5"
                                                       controls="controls" controlsList="nodownload noplaybackrate"></audio>
                                            </span>
                                            <span v-else-if="column === 'is_premium'">
                                                <img class="premium" src="/static/img/premium.png" v-if="item[column] === 1"/>
                                            </span>
                                            <span class="emodji" v-else-if="column === 'is_trendy'">
                                                <span class="text-success" v-if="item[column] === 1">🖤</span>
                                                <span class="text-warning" v-if="item[column] === 0"></span>
                                            </span>
                                            <span v-else-if="column === ''">
                                                <a class="text-primary" @click="edit(item['id'])">Изменить</a>
                                              </span>
                                                                    <span v-else-if="column === 'status'">
                                                <span class="text-success" v-if="item[column] === 1">Активен</span>
                                                <span class="text-warning" v-if="item[column] === 0">Не активен</span>
                                              </span>
                                            <span v-else>{{ item[column] }}</span>
                                        </td>
                                    </slot>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div :class="{ 'disabled' : data.length < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="next">
                            След.
                        </div>
                        <div :class="{ 'disabled' : offset < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="prev">
                            Пред.
                        </div>

                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";

const axios = require('axios')
import LTable from 'src/components/UIComponents/Table.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    components: {
        LTable,
        Card
    },
    created: function () {
        this.getAlbums();
    },
    data() {
        return {
            columns: ['id', 'album', 'src_full',  'image_src_full', 'artist', 'title', 'sort', 'status', ''],
            data: [],
            albums: [],
            album: localStorage.getItem('t_album') ? localStorage.getItem('t_album') : "",
            status: localStorage.getItem('t_status') ? localStorage.getItem('t_status') : "",
            loading: false,
            limit: 10,
            tracksCount: 0,
            offset: parseInt(localStorage.getItem('t_active_offset')) || 0,
            stats: {
                freeTracksCount: 0,
                premiumTracksCount: 0,
                averageTracksCount: 0,
                averageFreeCount: 0,
                averagePremiumCount: 0,
            }
        }
    },
    filters: {
        secondsToTime (value) {
            if (value) {
                return (Math.floor(value / 60)).toString() + ':' + (value % 60).toString();
            } else {
                return '';
            }
        }
    },
    methods: {
        init: function () {

        },
        filter: function () {
            localStorage.setItem('t_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        add: function () {
            this.$router.push('/tracks/create');
        },
        getAlbums: function () {
            let self = this;

            let token = localStorage.getItem('token');

            axios.get(
                `${this.$hostname}/admin/albums`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.albums = JSON.parse(JSON.stringify(response.data));

                    self.get();
                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        get: function () {
            let self = this;

            let token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(
                `${this.$hostname}/admin/tracks/`,
                {
                    'params': {
                        status: this.status,
                        album: this.album,
                        limit: this.limit,
                        offset: this.offset
                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    let data = response.data;
                    self.loading = false;

                    self.data = data.tracks;
                    self.tracksCount = data.count;

                })
                .catch(function (error) {
                    self.loading = false;
                    console.log(error)
                })
        },
        prev: function () {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('t_active_offset', parseInt(this.offset));
            }
        },
        next: function () {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('t_active_offset', parseInt(this.offset));
            }
        },
        edit: function (id) {
            this.$router.push({
                name: 'edit-track',
                params: {id: id}
            });
        },
        saveFilters: function(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave (to, from , next) {
        if (to.path.indexOf('tracks') < 1) {
            localStorage.setItem('t_active_offset', "0");
            localStorage.setItem('t_album', "");
            localStorage.setItem('t_status', "");
        }
        next();
    },
}
</script>
<style scoped>
.pagination-button {
    height: 30px;
    padding: 1px 16px;
    margin-left: 20px;
    color: #fff !important;
}
.pagination-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
audio {
    width: 250px;
}
.mt10 {
    margin-top: 10px;
}
.premium {
    width: 30px;
    margin-left: 20px;
}
.stats-block {
    margin-top: 10px;
    margin-bottom: 10px;
}
.stats-block > span {
    display: block;
    width: 100%;
    margin-left: 15px;
    margin-bottom: 3px;
}
.stats-block span span.number {
    font-weight: 700;
    font-size: 18px;
}
.emodji {
    font-size: 24px;
}
.device1 {
    display: block;
    width: 64px;
    height: 64px;
    border-radius: 8px;
    background-size: cover;
    cursor: pointer;
}

.btn-fill {
    margin-top: 25px;
}
.text-primary {
    cursor: pointer;
}
th {
    padding: 12px 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Tracks.vue